import { push } from "react-router-redux"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { notification } from "../../components"
import { login } from "../../helpers/requestHelper"
import { clearToken } from "../../helpers/utility"
import actions from "./actions"

const fakeApiCall = false // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery("LOGIN_REQUEST", function* () {
    if (fakeApiCall) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: "secret token",
      })
    } else {
      const username = localStorage.getItem("username")
      const password = localStorage.getItem("password")
      //yield put({ type: actions.LOGIN_ERROR });
    }
  })
}

export function* jwtLoginRequest() {
  yield takeEvery(actions.JWT_LOGIN_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(login, payload.userInfo)
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: result?.result?.token,
        userId: result?.result?.user?.objectId,
      })
      yield put(push("/dashboard"))
    } catch (error) {
      notification(
        "error",
        error?.response?.data?.result?.error || "Login failed"
      )
      yield put({
        type: actions.LOGIN_ERROR,
      })
    }
  })
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem("token", payload?.token)
    yield localStorage.setItem("userId", payload?.userId)
  })
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {})
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    clearToken()
    yield put(push("/"))
  })
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    try {
      const token = localStorage.getItem("token")
      const userId = localStorage.getItem("userId")
      if (token) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token,
          userId,
        })
      }
      // const id_token = getToken().get("id_token")
      // const token = getToken().get("token")
      // const role = getToken().get("role")
      // const user_id = getToken().get("user_id")
      // const expireTime = getToken().get("expireTime")
      // //console.log(`checkAuthorization id_token: ${id_token} | token : ${token} | user_id : ${user_id}`)
      // var currentTimestamp = Math.round(new Date().getTime() / 1000)
      // if (token && parseInt(id_token.split("|")[1]) > currentTimestamp) {
      //   yield put({
      //     type: actions.LOGIN_SUCCESS,
      //     token,
      //     role,
      //     user_id,
      //     id_token,
      //     expireTime,
      //   })
      // }
    } catch (e) {
      console.error("checkAuthorization error:", e)
    }
  })
}

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(jwtLoginRequest),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ])
}
